<h1 mat-dialog-title>Uitzondering {{ data.exception ? 'aanpassen' : 'toevoegen' }}</h1>
<div mat-dialog-content>
  <form [formGroup]="exceptionForm">
    <h4>Ik ben niet beschikbaar</h4>
    <mat-form-field class="name">
      <mat-label>Titel</mat-label>
      <input matInput type="text" autocomplete="off" formControlName="name" />
    </mat-form-field>
    <div class="date">
      <h5>Van</h5>
      <mat-form-field>
        <mat-label>Selecteer een van datum</mat-label>
        <!-- <mat-label>Selecteer een begin datum</mat-label> -->
        <input
          matInput
          [matDatepicker]="pickerFrom"
          formControlName="dateFrom"
          placeholder="01-01-2021"
          autocomplete="off"
        />
        <mat-datepicker-toggle matSuffix aria-label="Kalender openen" [for]="pickerFrom"></mat-datepicker-toggle>
        <mat-datepicker #pickerFrom></mat-datepicker>
        @if (exceptionForm.controls.dateFrom.errors?.required) {
          <mat-error>Dit veld is verplicht.</mat-error>
        }
        @if (exceptionForm.controls.dateFrom.errors?.pastDate) {
          <mat-error>De gekozen datum en tijd liggen in het verleden.</mat-error>
        }
      </mat-form-field>

      <div class="time">
        <!-- <h4>Selecteer een begin tijd</h4> -->
        <div class="time-content">
          <mat-form-field>
            <mat-label>Uur</mat-label>
            <mat-select formControlName="startHour" required>
              @for (hour of hours; track hour) {
                <mat-option [value]="hour.val">{{ hour.text }}</mat-option>
              }
            </mat-select>
            @if (exceptionForm.controls.startHour.errors?.required) {
              <mat-error>Dit veld is verplicht.</mat-error>
            }
          </mat-form-field>
          <mat-form-field class="min">
            <mat-label>Minuten</mat-label>
            <mat-select formControlName="startMin" required>
              @for (min of minutes; track min) {
                <mat-option [value]="min.val">{{ min.text }}</mat-option>
              }
            </mat-select>
            @if (exceptionForm.controls.startMin.errors?.required) {
              <mat-error>Dit veld is verplicht.</mat-error>
            }
          </mat-form-field>
        </div>
      </div>
      <!-- </div> -->

      <h5>Tot</h5>
      <mat-form-field>
        <mat-label>Selecteer een tot datum</mat-label>
        <input
          matInput
          [matDatepicker]="pickerTo"
          formControlName="dateTo"
          placeholder="01-01-2021"
          autocomplete="off"
        />
        <mat-datepicker-toggle matSuffix aria-label="Kalender openen" [for]="pickerTo"></mat-datepicker-toggle>
        <mat-datepicker #pickerTo></mat-datepicker>
        @if (exceptionForm.controls.dateTo.errors?.required) {
          <mat-error>Dit veld is verplicht.</mat-error>
        }
        @if (exceptionForm.controls.dateTo.errors?.pastDate) {
          <mat-error>De gekozen datum en tijd liggen in het verleden.</mat-error>
        }
      </mat-form-field>
      <div class="time">
        <div class="time-content">
          <mat-form-field class="hour">
            <mat-label>Uur</mat-label>
            <mat-select formControlName="endHour" required>
              @for (hour of hours; track hour) {
                <mat-option [value]="hour.val">{{ hour.text }}</mat-option>
              }
            </mat-select>
            @if (exceptionForm.controls.endHour.errors?.required) {
              <mat-error>Dit veld is verplicht.</mat-error>
            }
          </mat-form-field>
          <mat-form-field class="min">
            <mat-label>Minuten</mat-label>
            <mat-select formControlName="endMin" required>
              @for (min of minutes; track min) {
                <mat-option [value]="min.val">{{ min.text }}</mat-option>
              }
            </mat-select>
            @if (exceptionForm.controls.endHour.errors?.required) {
              <mat-error>Dit veld is verplicht.</mat-error>
            }
          </mat-form-field>
        </div>
      </div>
    </div>
  </form>
</div>
<div mat-dialog-actions align="end">
  <button mat-button [mat-dialog-close]>Annuleren</button>
  <button mat-flat-button (click)="addException()" cdkFocusInitial [disabled]="!exceptionForm.valid || loading()">
    @if (loading()) {
      <mat-spinner class="spinner" mode="indeterminate" diameter="20"></mat-spinner>
    }
    {{ data.exception ? 'Aanpassen' : 'Toevoegen' }}
  </button>
</div>
